import Service from '../services/SystemSettingsService';
import moment from 'moment';
export default {
    namespaced: true,
    state: {
        settings: {},
    },
    mutations: {
        setSettings(state, settings) {
            state.settings = settings;
        }
    },
    getters: {
        getOvertimeMins: (state) => (log) => {
            const diff = moment(log.end_time).diff(moment(log.start_time), 'minutes');
            const day = moment(log.start_time).format('ddd').toLowerCase();
            const standardHours = state.settings[day] || 0;
            const overtime = diff - (standardHours * 60);

            return overtime;
        }
    },
    actions: {
        loadOvertimeSettings ({commit}) {
            Service.loadSettings().then(({data}) => {
                const days = [
                    'mon',
                    'tue',
                    'wed',
                    'thu',
                    'fri',
                    'sat',
                    'sun',
                ];
                const settings = {};
                days.forEach(day => {
                    settings[day] = parseFloat(data['overtime_' + day] || 0);
                });
                commit('setSettings', settings);
            });
        },
    },
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/overtime.js